var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "10px",
    viewBox: "0 0 7 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DE1A70B0-9E1B-4ED9-B1CD-5756A9BA987B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "179.276506 13 184.428571 8 179.276506 3 178 4.23882951 181.875559 8 178 11.7611705"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance-agent-dashboard---2----policies-filters",
    transform: "translate(-224.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Policies-menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default-Menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy",
    transform: "translate(46.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Color-Copy-6"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#8592A3",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.1,
    fill: "#000000",
    xlinkHref: "#path-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowDash);
export default __webpack_public_path__ + "static/media/right-arrow-dash.3936e86f6e5de414c89bd4efdb5008cc.svg";
export { ForwardRef as ReactComponent };